export enum GlType {
	ATTRIBUTE = 'attribute',
	GLOBALS = 'globals',
	OUTPUT = 'output',
	PARAM = 'param',
	SDF_CONTEXT = 'SDFContext',
	SDF_MATERIAL = 'SDFMaterial',
	VARYING_WRITE = 'varyingWrite',
}
